import { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useProAccess } from "@/hooks/useProAccess";
import { canUseFamilyMessaging } from "@/lib/proAccessRules";

const Messages = lazy(() => import("@/pages/Messages"));
const RestrictedProMessages = lazy(() => import("@/pages/RestrictedProMessages"));

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center">
    <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
  </div>
);

const MessagesAccessRouter = () => {
  const { role, loading } = useAuth();
  const access = useProAccess();

  if (loading || (role === "pro" && access.status === "loading")) return <Loading />;

  // Pour un PRO, la messagerie avec les familles est accessible uniquement
  // lorsque le parcours requis est pleinement validé : profil essentiel,
  // abonnement (si requis) et vérification d'identité approuvée.
  // Les autres états sont redirigés vers la messagerie admin/support uniquement.
  const restrictedPro = !canUseFamilyMessaging(role, access.status);

  return (
    <Suspense fallback={<Loading />}>
      {restrictedPro ? <RestrictedProMessages /> : <Messages />}
    </Suspense>
  );
};

export default MessagesAccessRouter;
